/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_HowInputs */

const en_simple_home_banner_how = /** @type {(inputs: Simple_Home_Banner_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how it works`)
};

const id_simple_home_banner_how = /** @type {(inputs: Simple_Home_Banner_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat cara kerjanya`)
};

/**
* | output |
* | --- |
* | "See how it works" |
*
* @param {Simple_Home_Banner_HowInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_how = /** @type {((inputs?: Simple_Home_Banner_HowInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_HowInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_how(inputs)
	return en_simple_home_banner_how(inputs)
});